import {
  Box,
  Container,
  Typography,
  Grid,
  Link,
  IconButton,
  Divider,
} from "@mui/material";
import {
  Facebook,
  Instagram,
  YouTube,
  Email,
  Phone,
  LocationOn,
} from "@mui/icons-material";

export const Footer = () => {
  return (
    <Box
      component="footer"
      sx={{
        backgroundColor: "primary.main",
        color: "white",
        pt: 4,
        pb: 2,
      }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={4}>
          {/* Informações da Igreja */}
          <Grid item xs={12} md={4}>
            <Typography
              variant="h6"
              sx={{
                fontWeight: "bold",
                mb: 2,
                color: "white",
              }}
            >
              Igreja Evangélica Verbo da Vida - Campina Grande - Zona Sul
            </Typography>
            <Typography
              variant="body2"
              sx={{
                mb: 2,
                lineHeight: 1.6,
                opacity: 0.9,
              }}
            >
              Uma igreja comprometida com a palavra de Deus, levando esperança e
              transformação para todas as famílias.
            </Typography>
            {/* Redes Sociais */}
            <Box sx={{ display: "flex", gap: 1 }}>
              <IconButton
                sx={{
                  color: "white",
                  "&:hover": {
                    backgroundColor: "background.default",
                  },
                }}
              >
                <Facebook />
              </IconButton>
              <IconButton
                sx={{
                  color: "white",
                  "&:hover": {
                    backgroundColor: "background.default",
                  },
                }}
              >
                <Instagram />
              </IconButton>
              <IconButton
                sx={{
                  color: "white",
                  "&:hover": {
                    backgroundColor: "background.default",
                  },
                }}
              >
                <YouTube />
              </IconButton>
            </Box>
          </Grid>

          {/* Links Úteis */}
          <Grid item xs={12} sm={6} md={2}>
            <Typography
              variant="h6"
              sx={{
                fontWeight: "bold",
                mb: 2,
                color: "background.default",
              }}
            >
              Links
            </Typography>
            <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
              <Link
                href="#"
                sx={{
                  color: "background.default",
                  opacity: 0.9,
                  textDecoration: "none",
                  "&:hover": {
                    opacity: 1,
                    textDecoration: "underline",
                  },
                }}
              >
                Sobre Nós
              </Link>
              <Link
                href="#"
                sx={{
                  color: "background.default",
                  opacity: 0.9,
                  textDecoration: "none",
                  "&:hover": {
                    opacity: 1,
                    textDecoration: "underline",
                  },
                }}
              >
                Ministérios
              </Link>
              <Link
                href="#"
                sx={{
                  color: "background.default",
                  opacity: 0.9,
                  textDecoration: "none",
                  "&:hover": {
                    opacity: 1,
                    textDecoration: "underline",
                  },
                }}
              >
                Eventos
              </Link>
              <Link
                href="#"
                sx={{
                  color: "background.default",
                  opacity: 0.9,
                  textDecoration: "none",
                  "&:hover": {
                    opacity: 1,
                    textDecoration: "underline",
                  },
                }}
              >
                Doações
              </Link>
            </Box>
          </Grid>

          {/* Horários */}
          <Grid item xs={12} sm={6} md={3}>
            <Typography
              variant="h6"
              sx={{
                fontWeight: "bold",
                mb: 2,
                color: "background.default",
              }}
            >
              Horários de Culto
            </Typography>
            <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
              <Typography
                variant="body2"
                sx={{
                  color: "background.default",
                  opacity: 0.9,
                }}
              >
                <strong>Quarta-feira</strong>
                <br />
                15h - Culto das Mulheres
                <br />
                <strong>Quinta-feira</strong>
                <br />
                20h - Quinta especial
                <br />
                <strong>Sábado</strong>
                <br />
                19:30h - Culto de Jovens
                <br />
                <strong>Domingo</strong>
                <br />
                10h - Escola Dominical
                <br />
                18h - Culto de Celebração
                <br />
              </Typography>
            </Box>
          </Grid>

          {/* Contato */}
          <Grid item xs={12} md={3}>
            <Typography
              variant="h6"
              sx={{
                fontWeight: "bold",
                mb: 2,
                color: "background.default",
              }}
            >
              Contato
            </Typography>
            <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}>
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <LocationOn sx={{ fontSize: "1.2rem" }} />
                <Typography
                  variant="body2"
                  sx={{
                    color: "background.default",
                    opacity: 0.9,
                  }}
                >
                  Rua Isaque Catão, 123
                  <br />
                  Jardim Paulistano - CG-PB
                </Typography>
              </Box>
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <Phone sx={{ fontSize: "1.2rem" }} />
                <Typography
                  variant="body2"
                  sx={{
                    color: "background.default",
                    opacity: 0.9,
                  }}
                >
                  (83) 98737-6137
                </Typography>
              </Box>
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <Email sx={{ fontSize: "1.2rem" }} />
                <Typography
                  variant="body2"
                  sx={{
                    color: "background.default",
                    opacity: 0.9,
                  }}
                >
                  seccampinazonasul@verbodavida.com
                </Typography>
              </Box>
            </Box>
          </Grid>
        </Grid>

        {/* Divider */}
        <Divider sx={{ my: 3, backgroundColor: "background.default" }} />

        {/* Copyright */}
        <Box
          sx={{
            textAlign: "center",
          }}
        >
          <Typography
            variant="body2"
            sx={{
              color: "white",
              opacity: 0.8,
            }}
          >
            © 2026 Igreja Verbo da Vida. Todos os direitos reservados. •{" "}
            <Link
              href="#"
              sx={{
                color: "white",
                opacity: 0.8,
                "&:hover": {
                  opacity: 1,
                },
              }}
            >
              Política de Privacidade
            </Link>{" "}
            •{" "}
            <Link
              href="#"
              sx={{
                color: "white",
                opacity: 0.8,
                "&:hover": {
                  opacity: 1,
                },
              }}
            >
              Termos de Uso
            </Link>
          </Typography>
          <Typography
            variant="body2"
            sx={{
              color: "background.default",
              opacity: 0.8,
            }}
          >
            © 2026 Desenvolvido por Igor Pinheiro. Todos os direitos reservados.
            •{" "}
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};
